<template minapp='mpx' xlang='wxml'>
	<es-layout layout="{{['header', 'footer']}}" click-left="{{goback}}" class="es-edit" custom-class="contact-edit-custom-class">
		<!-- 导航栏 -->
		<view class="page-header" slot="header">
			<es-navbar
				class="es-edit__navbar"
				custom-class="es-edit__navbar"
				title="{{'编辑' + title + '信息'}}"
				leftArrow="{{false}}"
			>
				<view wx:if="{{!isHideLeftArrow}}" slot="left">
					<es-icon size="24" color="#333333" name="angle-left"></es-icon>
				</view>
				<view wx:if="{{!isNotShowDelete}}" slot="right" bindtap="handleDeleteContact">删除</view>
			</es-navbar>
		</view>
		<!-- <view style="height:12px"></view> -->

		<!-- 内容部分 -->
		<view wx:if="{{hasLoading}}">
			<es-content
				userId="{{userId}}"
				source="{{source}}"
				scene="{{scene}}"
				subType="{{sub_type}}"
				isNeedCard="{{isNeedCard}}"
				category="{{category}}"
				needApproval="{{need_approval}}"
				selected_card_type="{{card_type}}"
				is_tmp_traveler="{{is_tmp_traveler}}"
				is_my_tmp_traveler="{{is_my_tmp_traveler}}"
				isDelay="{{isDelay}}"
				isAddPage="{{false}}"
				wx:ref="contentRef"
				bind:change="changeDialog"
			/>
		</view>

		<!-- 保存 -->
		<view wx:if="{{!isMyself}}" slot="footer" class="es-edit__footer">
			<es-button block type="info" custom-class="es-edit__save" bind:click="handleSaveContact">
				保存
			</es-button>
		</view>

		<es-toast id="es-toast" />
		<es-dialog id="es-dialog"></es-dialog>
		<es-dialog
			showConfirmButton
			showCancelButton
			show="{{isDeleteDialogShow}}"
			bind:close="confirmDelete"
			class="es-edit__dialog es-contact__dialog"
			custom-header="es-edit__dialog-header"
			custom-body="es-edit__dialog-body"
			custom-confirm="es-edit__dialog-confirm"
			custom-cancel="es-edit__dialog-cancel"
		>
			<view slot="content"> 确认删除{{isExemption ? '常用旅客' : '联系人'}}{{ contactName }}吗? </view>
		</es-dialog>
	</es-layout>
	<filling-explanation show="{{isDialogShow}}" bind:close="changeDialog"> </filling-explanation>
</template>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { getStore } from '@/config/usex'
  import store from '@/store'
  import { formatDate } from '@didi/es-mpx-shared'
  import Validator from '@/utils/validator'
  import { PageSource, NeedCardType, SceneType, SubTypeConst, ApprovalType } from '@/utils/constants'
  import { USER_DEL_TOC } from '@/api/urls'
  import { deleteContact } from '@/api/contact/index'
  import Toast from '@didi/es-mpx-ui/lib/toast/functional'
  import { isWXMini, isALIMini } from '@/common/constant'
  import Dialog from '@didi/es-mpx-ui/lib/dialog/functional'
  import { getStorage } from '@/utils/storage'
  import { findIndex, cloneDeep } from 'lodash'
  import { titleConfig } from '@/config/content/index'
  import { innerRouter, pagePath } from "@/common/jump";

  createPage({
    data: {
      userId: '',
      source: PageSource.common,
      need_card: NeedCardType.yes,
      category: 'train',
      card_type: '1',
      isDeleteDialogShow: false,
      sub_type: SubTypeConst.self_personal,
      scene: SceneType.forPersonal,
      need_approval: ApprovalType.no,
      isDialogShow: false,
      is_tmp_traveler: 0,
      is_my_tmp_traveler: 0,
      hasLoading: false,
      title: '出行人',
      isDelay: false,
      passenger_source: null,
    },
    computed: {
      ...store.mapState({
        cardTypeList: 'newContacts.cardTypeList',
        contactDetail: 'newContacts.contactDetail',
        externalContacts: 'newContacts.externalContacts',
        is12306Login: 'login12306.is12306Login',// 是否已登录12306
      }),
      isExemption() {
        // 乘车人由原来的流程上区分是本地乘车人还是12306乘车人 改为 列表揉到一起 因此没办法再使用原来的免登录的标识做判断
        return this.passenger_source === '1' ? 1 : 0
      },
      isHideLeftArrow() {
        return isWXMini || isALIMini
      },
      isNeedCard() {
        return this.need_card === NeedCardType.yes
      },
      contactName() {
        return this.contactDetail?.list?.passenger_name ?? ''
      },
      isMyself() {
        return (this.contactDetail?.list?.is_user_self ?? '1') === '1'
      },
      isNotShowDelete() {
        // 1. 本人，不能删除
        // 1. 因公，需要差旅单，所有人不可以删除
        // 2. 因公，无须审批，除自己维护因公外部出行人，不可以删除
        // return (
        // 	this.isMyself ||
        // 	(this.scene == SceneType.forBusiness && this.need_approval == NeedCardType.yes) ||
        // 	(this.scene == SceneType.forBusiness &&
        // 		this.need_approval == NeedCardType.no &&
        // 		this.sub_type != SubTypeConst.self_business)
        // )
        return this.isMyself && !this.isExemption
      }
    },
    methods: {
      ...store.mapMutations({
        clearContactDetail: 'newContacts.clearContactDetail',
        clearCardTypeList: 'newContacts.clearCardTypeList',
        setNationality: 'newContacts.setNationality',
        setExternalContacts: 'newContacts.setExternalContacts',
        setContactSelected: 'newContacts.setContactSelected',
        contactDetailSuccess: 'newContacts.contactDetailSuccess'
      }),
      ...store.mapActions({
        getCardTypeListAction: 'newContacts.getCardTypeListAction',
        getContactDetailAction: 'newContacts.getContactDetailAction',
        deleteContactDetailAction: 'newContacts.deleteContactDetailAction'
      }),
      // viewUpdate() {
      //   this.$forceUpdate()
      // },
      changeDialog() {
        this.isDialogShow = !this.isDialogShow

        // h5 让所有的输入框失去焦点
        if (__mpx_mode__ === 'web') {
          document.querySelectorAll('input')?.forEach((item) => {
            item.blur()
          })
        }
      },
      async init(is_tmp_traveler) {
        // 页面初始化时，清空历史数据
        this.clearCardTypeList()
        await this.getCardTypeListAction({
          category: this.category,
          need_card: NeedCardType.yes
        })
        let selectIndex = this.externalContacts.findIndex((item) => item.id == this.userId)
        if (is_tmp_traveler != 1 || selectIndex === -1) {
          this.clearContactDetail({})
          this.getContactDetailAction({ 
            contact_id: this.userId,
            passenger_source: this.passenger_source,
            order_type: this.isExemption || Number(!this.is12306Login)
          })
        } else {
          this.clearContactDetail({})
          setTimeout(() => {
            let contactDetail = this.externalContacts[selectIndex]
            this.contactDetailSuccess({ data: contactDetail })
          })
        }
        this.hasLoading = true
      },
      goback() {
        innerRouter.goback()
      },
      handleSaveContact() {
        if (this.$refs['contentRef']) {
          this.$refs['contentRef'].saveContact()
        }
      },
      handleDeleteContact() {
        this.isDeleteDialogShow = !this.isDeleteDialogShow
      },
      confirmDelete(e) {
        if (e.detail === 'confirm') {
          const { userId, sub_type } = this.$mpxRoute.query
          if (!this.is_tmp_traveler) {
            const conatctInfo = this.contactDetail?.list ?? {}
            mpx.$http
              .post(USER_DEL_TOC, {
                data: {
                  contact_id: userId,
                  passenger_source: this.passenger_source,
                  order_type: this.isExemption || Number(!this.is12306Login),
                  user: {
                    passenger_name: this.contactName,
                    id_no: conatctInfo?.id_no ?? '',
                    id_type: conatctInfo?.id_type ?? ''
                  }
                }
              })
              .then((res) => {
                if (+res?.code !== 0) {
                  Toast({
                    message: res.message,
                    overlay: false
                  })
                } else {
                  Toast({
                    message: res?.data?.msg,
                    overlay: false,
                    duration: 1000
                  })
                  if (res?.data?.is_success) {
                    this.deleteContactDetailAction({
                      id: userId
                    })
                    setTimeout(() => innerRouter.goback(), 1000)
                  }
                }
              })
          } else {
            let data = {
              id: userId,
              isDelet: true
            }
            this.setExternalContacts(data)

            setTimeout(() => {
              this.contactDetailSuccess({ data: { id: data.id, isDel: true } })
            }, 500)

            this.setContactSelected({ data, fn: 'reduce' })
            innerRouter.goback()
          }
        }
      }
    },
    mounted() {
      mpx.setNavigationBarColor({ frontColor: '#000000' })
      const {
        userId,
        card_type,
        need_card,
        source,
        category,
        sub_type,
        scene,
        need_approval,
        is_tmp_traveler,
        is_my_tmp_traveler,
        isDelay,
        passenger_source
      } = this.$mpxRoute.query
      this.userId = userId
      this.passenger_source = passenger_source
      this.source = source || PageSource.common // 页面来源 1-常用 2-选择
      this.need_card = need_card || NeedCardType.yes // 是否需要证件信息 1是 0否
      this.card_type = card_type || '' // 证件类型
      this.title = titleConfig[this.category] // 页面标题
      this.sub_type = sub_type || SubTypeConst.self_personal // 人员类型，4-个人因私出行人
      this.scene = scene || SceneType.forPersonal // 场景
      this.need_approval = need_approval || ApprovalType.no // 是否需要审批
      this.is_tmp_traveler = Number(is_tmp_traveler)
      this.is_my_tmp_traveler = Number(is_my_tmp_traveler)
      this.isDelay = Boolean(isDelay)
      this.init(is_tmp_traveler)
      this.hasLoading = false
    },
    activated() {
      this.$forceUpdate()
    },
    destroyed() {
      this.setNationality({})
    }
  })
</script>

<style lang='stylus' scoped>
  +b('edit')
    /deep/ .es-main
      background-color #f0f1f4
    /deep/ .es-toast
      background-color #000000
      padding 12px 24px
    /deep/ .es-card__body
      padding 0 12px
    /deep/ .es-icon-angle-right
      font-size 20px !important
      color #999999 !important
    +e('navbar')
      background-color #ffffff
      height 44px !important
      z-index auto !important
      /deep/ .es-navbar
        height 60px
      /deep/ .es-navbar__right
        width 28px
      /deep/ .es-navbar__title
        font-size 18px
    +e('save')
      border-radius 8px !important
      font-size 16px !important
      /deep/ button
        border-radius 8px
    +e('footer')
      width 100%
      padding 16px
      background-color #ffffff
      box-shadow 0 -4px 20px 0 rgba(0, 0, 0, 0.04)
      z-index 1
    // 小程序用
    +e('dialog-header')
      display none !important
    // 小程序用
    +e('dialog-body')
      font-size 16px !important
      font-weight bold !important
      padding 20px 24px !important
    // 小程序用
    +e('dialog-confirm')
      /deep/ button
        color #1473ff !important
    // 小程序用
    +e('dialog-cancel')
      /deep/ button
        color #1473ff !important
        border-right none
</style>

<script name='json'>
  module.exports = {
    // "navigationBarTitleText": "编辑出行人信息",
    usingComponents: {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-layout': '@/es-mpx-ui/lib/layout',
      'es-content': './components/content',
      'es-button': '@didi/es-mpx-ui/lib/button',
      'es-toast': '@didi/es-mpx-ui/lib/toast',
      'es-dialog': '@didi/es-mpx-ui/lib/dialog',
      'filling-explanation': './components/filling-explanation'
    }
  }
</script>

